<template>
  <div class="box">
    <el-form-item label="说明文字">
      <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="editing.data.title"> </el-input>
    </el-form-item>

    <el-form-item label="控件类型">
      <div>{{ editing.name }}</div>
    </el-form-item>
  </div>
</template>
<script>
export default {
  name: 'TipsSetting',
  props: {
    editing: Object
  }
}
</script>
<style lang="scss" scoped>
.box {
  position: relative;
  padding-top: 20px;
}
</style>
